// extracted by mini-css-extract-plugin
module.exports = {"container":"cg-z","creativeContainer":"dg-z","copy":"eg-z","cta":"fg-z","disabled":"gg-z","flipped":"hg-z","card":"ig-z"};